
import ReactModal from "react-modal";
import React from "react";
import { deleteClient } from "../../api";
import { useNavigate } from "react-router-dom";

type propsType = {
    openDelete: boolean
    setOpenDelete: React.Dispatch<React.SetStateAction<boolean>>
    concretClient: any,
    setConcretClient: React.Dispatch<React.SetStateAction<any>>,
}

function DeleteClient({ openDelete, setOpenDelete, concretClient, setConcretClient }: propsType) {

    const navigate = useNavigate();
    const closeWindow = (): void => {
        setConcretClient(null);
        setOpenDelete(false)
    }

    const deleteThisClient = async (): Promise<void> => {
        const deleteData = await deleteClient(concretClient.id);
        if (deleteData) {
            closeWindow();
            navigate("/clients");
        }
    }

    return (
        <ReactModal
            isOpen = { openDelete }
            onRequestClose = { () => closeWindow() }
            style = {{
                overlay: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.2)',
                    zIndex: 300,
                },
                content: {
                    width: "80%",
                    maxWidth: '550px',
                    maxHeight: "240px",
                    height: "55vh",
                    border: 'none',
                    margin: "auto",
                    borderRadius: "10px",
                    background: 'white',
                    WebkitOverflowScrolling: 'touch',
                    outline: 'none',
                    overflowY: "auto",
                    display: "flex",
                    flexDirection: 'column',
                    alignItems: "center",
                    justifyContent: "space-evenly",
                }
            }}
        >
            <div className = 'modal-deleteClient-content'>
                Do You Want to Delete this Client?
            </div>
            <p className = "concretClienFullName">{ concretClient.firstName + " " + concretClient.lastName }</p>
            <div className = 'modal-deleteClient-actions'>
                <button className = "rejectAction" onClick = { closeWindow }>
                    No
                </button>
                <button className = "confirmAction" onClick = { deleteThisClient }>
                    Yes
                </button>
            </div>
        </ReactModal>
    )
}

export default DeleteClient
